(() => {
  const safeValue = (value) => {
    if (value === undefined || value === null || typeof value === 'boolean' || typeof value === 'number') return value;
    return String(value).slice(0, 80);
  };

  const track = (name, properties = {}) => {
    if (!name) return;
    const privacy = window.Shopify?.customerPrivacy;
    const analyticsAllowed = typeof privacy?.analyticsProcessingAllowed === 'function'
      ? privacy.analyticsProcessingAllowed() === true
      : window.RoamUnoAnalyticsConsent === true;
    if (!analyticsAllowed) return;
    const clean = Object.fromEntries(Object.entries(properties).filter(([, value]) => value !== undefined && value !== null).map(([key, value]) => [key, safeValue(value)]));
    if (typeof window.Shopify?.analytics?.publish === 'function') {
      Promise.resolve(window.Shopify.analytics.publish(`roamuno_${name}`, clean)).catch(() => {});
    }
  };

  window.RoamUnoAnalytics = window.RoamUnoAnalytics || {};
  window.RoamUnoAnalytics.track = track;

  const main = document.querySelector('main[data-template]');
  let productViewTracked = false;
  const trackProductView = () => {
    if (productViewTracked || main?.dataset.template !== 'product' || window.RoamUnoAnalyticsConsent !== true) return;
    productViewTracked = true;
    track('product_view', { handle: main.querySelector('[data-product-handle]')?.dataset.productHandle });
  };
  trackProductView();
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', trackProductView, { once: true });
  document.addEventListener('visitorConsentCollected', trackProductView, { once: true });

  document.addEventListener('change', (event) => {
    const filter = event.target.closest('[data-plan-filter]');
    if (filter) track('plan_filter', { filter: filter.name, selected: Boolean(filter.value) });
    const sort = event.target.closest('[data-plan-sort]');
    if (sort) track('plan_sort', { sort: sort.value });
    const variant = event.target.closest('variant-selects, [data-product-form]');
    if (variant) track('variant_select', { product: main?.dataset.template === 'product' });
  }, { passive: true });

  document.addEventListener('click', (event) => {
    const scope = event.target.closest('[data-plan-scope]');
    if (scope) track('plan_scope', { scope: scope.dataset.planScope });

    const add = event.target.closest('button[name="add"], [data-sticky-submit]');
    if (add) track('add_to_cart', { product: main?.dataset.template === 'product' });

    const checkout = event.target.closest('a[href*="/checkout"], button[name="checkout"], [data-direct-checkout]');
    if (checkout) track('begin_checkout');

    const support = event.target.closest('a[href*="/pages/contact"]');
    if (support) track('support_open', { location: main?.dataset.template || 'page' });

    const compatibility = event.target.closest('[data-compatibility-check]');
    if (compatibility) track('compatibility_check', { result: compatibility.dataset.compatibilityCheck });
  }, { passive: true });

  document.addEventListener('submit', (event) => {
    if (event.target.matches('[data-trip-planner]')) track('destination_search');
  }, { passive: true });
})();
